const Colors = {
  primary: "#007bff",
  secondary: "#87CEEB",
  orange: "#FFA500",
};

export default Colors;
